module.exports = __webpack_public_path__ + "img/keder_beige_ral1014.79422660.jpg";